/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
 */

import pluginFactory from 'taoTests/runner/plugin';

/**
 * This plugin notifies the parent window of all the events of the TestRunner life-cycle
 */
export default pluginFactory({
    name: 'notify',

    init() {
        if (window.parent) {
            const testrunner = this.getTestRunner();
            const targetOrigin = '*';
            const notify = (event, parameters = {}) => {
                window.parent.postMessage({ event, parameters }, targetOrigin);
            };
            testrunner
                .on('init', () => notify('init'))
                .on('render', () => notify('render'))
                .on('loaditem', itemIdentifier => notify('loaditem', { itemIdentifier }))
                .on('renderitem', itemIdentifier => notify('renderitem', { itemIdentifier }))
                .on('unloaditem', itemIdentifier => notify('unloaditem', { itemIdentifier }))
                .on('enableitem', itemIdentifier => notify('enableitem', { itemIdentifier }))
                .on('disableitem', itemIdentifier => notify('disableitem', { itemIdentifier }))
                .on('finish', () => notify('finish'))
                .on('flush', () => notify('flush'))
                .on('error', error => notify('error', { error }))
                .on('destroy', () => notify('destroy'));
        }
    }
});
